<script setup lang="ts">
import Callout from "@/components/Callout.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { useRoleLowered } from "@/components/roleLowered";

/**
 * 드로어 · 모달 안 「역할이 내려갔습니다」 줄(83차 JR83-05) — `DefaultLayout` 의 머리 배너가 이 층들 뒤에 가려지므로 열린 층 머리 아래에 같은 안내를 한 번 더 둔다.
 * 문맥(`roleLowered.ts`)이 켜져 있을 때만 그리고, 문장은 머리 배너의 강등 문장과 같다(「화면에 남은 입력이 있으면 옮겨 적은 뒤 화면을 다시 불러오세요」 — 입력칸이 사라지는 화면에서도 사실이 되게 조건을 둔다).
 * 낭독은 머리 배너의 `role="status"` 가 이미 읽는다 — 여기는 눈으로 보는 자리라 따로 낭독 역할을 주지 않는다.
 */
const roleLowered = useRoleLowered();
</script>

<template>
  <Callout
    v-if="roleLowered?.active.value"
    class="ui-role-lowered-strip"
    tone="warn"
    icon
    title="역할이 바뀌었습니다 — 권한이 줄어 저장할 수 없습니다"
  >
    <p>
      권한이 줄어 이 화면에서 저장할 수 없습니다. 화면에 남은 입력이 있으면 옮겨
      적은 뒤 화면을 다시 불러오세요.
    </p>
    <template #actions>
      <LoadingButton
        variant="ghost"
        size="sm"
        icon="refresh"
        @click="roleLowered.reload()"
      >
        화면 다시 불러오기
      </LoadingButton>
    </template>
  </Callout>
</template>

<style scoped>
/* 층 머리와 본문 사이 — 층 안쪽 여백에 맞춰 양옆을 두고 아래 본문과 띄운다 */
.ui-role-lowered-strip {
  flex: none;
  margin: var(--ui-gap-md) var(--ui-pad-card) 0;
}
</style>
